import React from "react";
import { Button, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import "./HasarIhbarPage.css";
import { useHasar } from "./HasarContext";
import hasarBanner from "./assets/hasar-ihbar-banner.png";
import { ToolOutlined, UserOutlined } from "@ant-design/icons";

const { Title } = Typography;

function HasarIhbarPage() {
    const navigate = useNavigate();
    const { setServisTipi } = useHasar();

    const handleRedirect = () => {
        window.location.href = "https://www.zurichsigorta.com.tr/hasar-aninda";
    };

    const handleHasarTip = (tip) => {
        setServisTipi(tip);
        navigate("/hasarTipi");
    };

    return (
        <div className="hasar-ihbar-page">
            <div className="hasar-header">
                <div className="hasar-title">
                    <Title level={2} style={{ color: "#2196f3", marginBottom: 0/*, textAlign: "center"*/, }}>
                        Hasar İhbarı
                    </Title>
                    <Title level={2} style={{
                        color: "#000", fontWeight: 400, marginBottom: 0, fontStyle: "italic"
                    }}>
                        Hasar İhbarında Bulunan Kim?
                    </Title>
                </div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>

                </div>
                <div className="hasar-image">
                    <img src={hasarBanner} alt="Hasar İhbar" />
                </div>
            </div>
            <div className="hasar-content">
                <Row gutter={32} justify="center">
                    <Col xs={24} md={10} className="hasar-col">
                        <div style={{ textAlign: "center", marginBottom: 8 }}>
                            <ToolOutlined style={{ fontSize: 48, color: "#005baa" }} />
                        </div>
                        <Title level={3} style={{ textAlign: "center", color: "#005baa", fontWeight: 800 }}>Servis Giriş</Title>
                        <Button block type="primary" className="hasar-btn" onClick={() => handleHasarTip(1)}>Anlaşmalı Servis</Button>
                        <Button block type="primary" className="hasar-btn" onClick={() => handleHasarTip(0)}>Anlaşmasız Servis</Button>
                    </Col>
                    <Col xs={24} md={10} className="hasar-col">
                        <div style={{ textAlign: "center", marginBottom: 8 }}>
                            <UserOutlined style={{ fontSize: 48, color: "#005baa" }} />
                        </div>
                        <Title level={3} style={{ textAlign: "center", color: "#005baa", fontWeight: 800 }}>Bireysel Giriş</Title>
                        <Button block type="primary" className="hasar-btn" onClick={handleRedirect}>Zurich Sigorta Müşterisiyim / Sigortalı</Button>
                        <Button block type="primary" className="hasar-btn" onClick={handleRedirect}>Zurich Sigortalısı Tarafından Zarar Verilen Kişiyim / Mağdur</Button>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default HasarIhbarPage;
